import { render } from "./voters.vue?vue&type=template&id=32b941fc&scoped=true"
import script from "./voters.vue?vue&type=script&lang=js"
export * from "./voters.vue?vue&type=script&lang=js"

import "./voters.vue?vue&type=style&index=0&id=32b941fc&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/2026_cdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b941fc"]])

export default __exports__